export const formatString = (s: string, word: string) => {
  return s.replace("%s", word);
}

export const formatInt = (s: String, num: Number) => {
  return s.replace("%d", String(num));
}


